<div class="manager_sidebar" [class.manager_expanded]="isManagerExpanded">
    <div class="manager_toggle-btn" (click)="toggleManagerSidebar()">
      <mat-icon *ngIf="!isManagerExpanded" matSuffix class="manager_arrow"
        style="vertical-align:sub; border: 1px solid white;border-radius: 12px;padding-bottom: 23px;">chevron_right</mat-icon>
      <mat-icon *ngIf="isManagerExpanded" matSuffix class="manager_arrow"
        style="vertical-align:sub; border: 1px solid white;border-radius: 12px;padding-bottom: 23px; padding-right: 24px;">chevron_left</mat-icon>
    </div>
    <div class="manager_profile_block">
      <div *ngIf="ManagerNameAsPhoto" class="manager_profile_letter">{{ManagerNameAsPhoto}}</div>
      <div *ngIf="isManagerExpanded" class="manager_profile_name">{{ManagerName}}
        <mat-icon class="material-symbols-outlined" style="vertical-align: top; margin-left: 10px;" 
          (click)="toggleSecondManagerSidebar()">repeat</mat-icon>
      </div>
      <div *ngIf="isManagerExpanded" class="manager_profile_name">Client Name: {{ClientProfileName}}</div>
      <div *ngIf="isManagerExpanded" class="manager_profile_name">Business Name: {{BusinessProfileName}}</div>
    </div>
    <div class="manager_content_bar">
      <!-- <div class="manager_sidebar_text" *ngIf="isManagerExpanded" style="margin-left: 30px;font-size: 18px;margin-bottom: 10px;">30/10/2024 Product Expiry</div> -->
      <div class="manager_menu_item" routerLink="/ManagerDashboard/ProfilePage" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">person</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Profile</div>
      </div>
      <div class="manager_menu_item" routerLink="/ManagerDashboard/ClientList" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">calendar_month</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Client List</div>
      </div>
      <div class="manager_menu_item" routerLink="/ManagerDashboard/ClientBusinesses" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">business_center</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Client Businesses</div>
      </div>
      <div class="manager_menu_item" routerLink="/ManagerDashboard/CreatePost" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">group</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Create Post</div>
      </div>
      <div class="manager_menu_item" routerLink="/ManagerDashboard/Voucher" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">local_activity</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Voucher</div>
      </div>
      <!-- <div class="manager_menu_item" routerLink="/Dashboard/PaymentHistory" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">payments</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Payment History</div>
      </div>
      <div class="manager_menu_item" routerLink="/Dashboard/Plans" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">query_stats</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Plans</div>
      </div> -->
      <div class="manager_menu_item" routerLink="/ManagerLogin" routerLinkActive="manager_active-menu">
        <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">logout</mat-icon>
        <div class="manager_sidebar_text" *ngIf="isManagerExpanded">Logout</div>
      </div>
    </div>
  </div>
  <div *ngIf="isSecondSidebarManagerExpanded" class="manager_second-sidebar" [class.manager_expanded]="isSecondSidebarManagerExpanded">
    <div class="manager_toggle-btn" (click)="toggleSecondManagerSidebar()">
      <mat-icon *ngIf="isSecondSidebarManagerExpanded" matSuffix class="manager_arrow"
        style="vertical-align:sub; border: 1px solid white; border-radius: 12px; padding-bottom: 23px; padding-right: 24px;">
        close
      </mat-icon>
    </div>
  
    <div class="manager_content_bar client_bar">
      <div class="manager_user_business_title" style="font-size: 26px;">Client Names</div>
      <div class="manager_business_item" *ngFor="let clientinfo of ManagerClientData; let i = index">
        <div class="manager_user_business_name" >
            <div class="manager_user_client_info" >{{ clientinfo.ClientFullName }}
              <mat-icon class="material-symbols-outlined" style="vertical-align: top; margin-left: 10px;float: right;" 
                (click)="onSwitch(i)">repeat</mat-icon></div>
            <div class="manager_user_business_info" >{{ clientinfo.BusinessInfo_BusinessName }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="manager_content_page">
    <router-outlet></router-outlet>
  </div>
  